import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Box, Tab, Tabs, tabsClasses } from '@mui/material'
import * as React from 'react'
import { MUITabsModel } from '../../../Models'
import MUITooltip from '../MUI-Tooltip'

const MUITabs: React.FC<MUITabsModel> = ({
  listing = false,
  tabs = [],
  currentTab = '',
  handleChange = () => {
    return
  },
  scrollButtons = false,
  arrowMarginTop = '0px',
}) => {
  const StartScrollButtonIcon = React.useCallback(
    () => (
      <MUITooltip title={'Scroll Left'} arrow>
        <KeyboardArrowLeft />
      </MUITooltip>
    ),
    [],
  )

  const EndScrollButtonIcon = React.useCallback(
    () => (
      <MUITooltip title='Scroll Right' arrow>
        <KeyboardArrowRight />
      </MUITooltip>
    ),
    [],
  )
  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={currentTab}
        onChange={handleChange}
        aria-label='secondary tabs example'
        className={`${listing ? 'tab-c' : ''}`}
        variant='scrollable'
        scrollButtons={scrollButtons ? true : false}
        sx={{
          [`& .${tabsClasses.scrollButtons}`]: {
            marginTop: arrowMarginTop,
            '&.Mui-disabled': { opacity: 0.3 },
          },
        }}
        {...(scrollButtons && {
          TabScrollButtonProps: {
            slots: {
              StartScrollButtonIcon,
              EndScrollButtonIcon,
            },
          },
        })}
      >
        {tabs.map((tab: any) => (
          <Tab
            data-testid={tab?.id ? tab.id : tab?.label}
            value={tab?.value}
            key={tab?.value}
            label={
              tab?.showSuccessCheck ? (
                <div className='d-flex align-items-center' style={{ gap: '5px' }}>
                  {tab?.label}
                  <CheckCircleIcon sx={{ color: '#005a30', fontSize: '20px' }} />
                </div>
              ) : (
                tab?.label
              )
            }
            sx={{
              fontWeight: 600,
              textTransform: 'capitalize',
              background: '#ffff',
              height: '38px',
            }}
            disabled={tab?.disable}
          />
        ))}
      </Tabs>
    </Box>
  )
}

export default MUITabs
